<template>
	<div class="full zhe">
		<transition name="fade">
			<div class="full" v-if="card==-1">
				<div class="box_bg"><img src="../img/box_bg.png" /></div>
				<div class="box_button_off" v-show="!beginButton" v-hammer:tap="begin"><img src="../img/box_button_off.png" />
				</div>
				<div class="box_button_on" v-show="beginButton"><img src="../img/box_button_on.png" /></div>
				<div class="box_back" v-hammer:tap="back"><img src="../img/box_back.png" /></div>
				
				<div class="box_light box_light1" v-show="index==1"><img src="../img/box_light_1.png" /></div>
				<div class="box_light box_light2" v-show="index==2" style="width: 20.7%;"><img src="../img/box_light_2.png" />
				</div>
				<div class="box_light box_light3" v-show="index==3"><img src="../img/box_light_3.png" /></div>
				<div class="box_light box_light4" v-show="index==4"><img src="../img/box_light_1.png" /></div>
				<div class="box_light box_light5" v-show="index==5" style="width: 20.7%;"><img src="../img/box_light_2.png" />
				</div>
				<div class="box_light box_light6" v-show="index==6"><img src="../img/box_light_3.png" /></div>
			</div>
		</transition>
		<transition name="fade">
			<div class="full" v-if="card!=-1">
				<div class="full" v-if="card==0">
					<div class="box_ele2 rotate"><img src="../img/box_ele2.png" /></div>
					<div class="box_ele3 animated fadeInUp"><img src="../img/box_ele3.png" /></div>
					<div class="box_ele1 animated zoomIn" v-hammer:tap="gift"><img src="../img/box_ele1.png" /></div>
					<div class="box_back" v-hammer:tap="back" style="left: 70.3%;top: 26.3%;"><img src="../img/box_back.png" /></div>
					
				</div>	
	
				<div class="card_container1" v-if="card==1">
					<div class="card animated fadeIn"><img src="../img/card_1.png" /></div>
					<div class="card_1_button_off animated fadeInUp" v-show="!buttonBuff" v-hammer:tap="gethongbao">
						<img src="../img/card_1_button_off.png" />	
					</div>
					<!-- <div class="card_1_button_on" v-show="buttonBuff"><img src="../img/card_1_button_on.png" /></div> -->
					<div class="box_back" v-hammer:tap="back" style="left: 79.6%;top: 20.6%;"><img src="../img/box_back.png" /></div>
				</div>
				<div class="card_container2" v-if="card==2">
					<div class="card animated fadeIn"><img src="../img/card_2.png" /></div>
					<div class="card_2_button_off animated fadeInUp" v-show="!buttonBuff">
						<img src="../img/card_2_button_off.png" />
						<div class="full" >
							<wx-open-launch-weapp class="launch-btn" id="launch-btn" username="gh_7ee3d23f0aa9"
								path="pages/games/store">
								<script type="text/wxtag-template">
									<style>.btn { width: 1000px; height: 1000px;}</style>
									<button class="btn" style="margin: auto;">打开小程序视频</button>
								</script>
							</wx-open-launch-weapp>
						</div>
					</div>
					<!-- <div class="card_2_button_on" v-show="buttonBuff"><img src="../img/card_2_button_on.png" /></div> -->
					<div class="box_back" v-hammer:tap="back" style="left: 79.6%;top: 20.6%;"><img src="../img/box_back.png" /></div>
				</div>
				<div class="card_container3" v-if="card==3">
					<div class="card hb" ref="model">
						<img v-if="hbtype==1" src="https://h5.huierkj.com/Qzmilk/img/hb_1.png" />
						<img v-if="hbtype==2" src="https://h5.huierkj.com/Qzmilk/img/hb_2.png" />
						<img v-if="hbtype==3" src="https://h5.huierkj.com/Qzmilk/img/hb_3.png" />
						<img v-if="hbtype==4" src="https://h5.huierkj.com/Qzmilk/img/hb_4.png" />
						<img v-if="hbtype==5" src="https://h5.huierkj.com/Qzmilk/img/hb_5.png" />
						<div class="hb_head"><img :src="userInfo.headimgurl" /></div>
						<div class="hb_name">{{userInfo.nickname}}</div>
					</div>
					<div class="card_3_button_off" style="overflow: hidden;" v-show="!buttonBuff">
						<img src="../img/card_3_button_off.png" />
						<div class="HB full" style="opacity: 0;overflow: hidden;" v-if="hb!=''"><img :src="hb" /></div>
					</div>
					<!-- <div class="card_3_button_on" v-show="buttonBuff"><img src="../img/card_3_button_on.png" /></div> -->
					<div class="box_back" v-hammer:tap="back" style="left: 79.6%;top: 18.6%;"><img src="../img/box_back.png" /></div>
				</div>
				<transition name="fade">
					<abpage v-if="shareShow" v-hammer:tap="shareHide">
						<div class="full zhe">
							<div class="share_ele1"><img  src="../img/share_ele1.png"/></div>
						</div>
					</abpage>
				</transition>
			</div>
		</transition>
		<transition name="fade">
			<hb v-if="hbShow" @back="back" />
		</transition>
		
		
	</div>
</template>

<style scoped>
	.hb_head{
		position: absolute;
		width: 22%;
		height: 14.1%;
		left: 13.5%;
		top: 73.2%;
		border-radius: 10px;
		box-sizing: border-box;
		border: 2px solid #eeb566;
		overflow: hidden;
	}
	.hb_name{
		position: absolute;
		width: 22%;
		left: 13.5%;
		top: 88%;
		color: white;
		text-align: center;
		font-size: 3vw;
	}
	.launch-btn {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 9;
		overflow: hidden;
		opacity: 0;
	}
	.card{
		position: absolute;
		width: 64.3%;
		left: 17.9%;
		top: 21.7%;			
	}
	.card_1_button_off{
		position: absolute;
		width: 51.1%;
		left: 24.5%;
		top: 75.6%;			
	}
	.card_1_button_on{
		position: absolute;
		width: 51.1%;
		left: 24.5%;
		top: 76%;				
	}
	.card_2_button_off{
		position: absolute;
		width: 51.1%;
		left: 24.5%;
		top: 75.6%;			
	}
	.card_2_button_on{
		position: absolute;
		width: 51.1%;
		left: 24.5%;
		top: 76%;				
	}
	.card_3_button_off{
		position: absolute;
		width: 51.1%;
		left: 24.5%;
		top: 75.6%;			
	}
	.card_3_button_on{
		position: absolute;
		width: 51.1%;
		left: 24.5%;
		top: 76%;				
	}	
	
	.box_ele1{
		position: absolute;
		width: 58.8%;
		left: 20.7%;
		top: 31.5%;		
	}
	.box_ele2{
		position: absolute;
		width: 84.7%;
		left: 7.2%;
		top: 28.9%;		
	}	
	.box_ele3{
		position: absolute;
		width: 32.4%;
		left: 33.1%;
		top: 64.6%;		
	}
	.box_bg {
		position: absolute;
		width: 84.4%;
		left: 8.1%;
		top: 16.9%;
	}

	.box_button_off {
		position: absolute;
		width: 58.1%;
		left: 26.1%;
		top: 67.4%;
	}

	.box_button_on {
		position: absolute;
		width: 58.1%;
		left: 26.1%;
		top: 68.4%;
	}

	.box_back {
		position: absolute;
		width: 7.2%;
		left: 88.3%;
		top: 14.8%;
	}

	.box_light {
		position: absolute;
		width: 20.9%;
	}

	.box_light1 {
		left: 19.6%;
		top: 31.1%;
	}

	.box_light2 {
		left: 39.7%;
		top: 31.1%;
	}

	.box_light3 {
		left: 59.7%;
		top: 31.1%;
	}

	.box_light4 {
		left: 19.6%;
		top: 44.3%;
	}

	.box_light5 {
		left: 39.7%;
		top: 44.3%;
	}

	.box_light6 {
		left: 59.7%;
		top: 44.3%;
	}
	.hb{
		width: 85.9%;
		height: 64.4%;
		left: 7.3%;
		top: 14.1%;
	}
</style>
<script>
	//let Base64 = require('js-base64').Base64;
	import html2canvas from 'html2canvas';
	import OSS from 'ali-oss'	
	export default {
		data() {
			return {
				index: 0,
				round: 5,
				beginButton: false,
				runBuff: false,
				buttonBuff:false,
				card:-1,
				money:0,
				hongbaoPath:'pages/games/money',
				hb:'',
				hbtype:0,
				shareShow:false,
				hbShow:false
			};
		},
		computed: {
			userInfo(){
				return this.$store.state.userInfo
			}
		},
		created(){

			//console.log(Base64.decode(decodeURIComponent(this.userInfo.unionid)),Base64)
		},
		mounted() {

		},
		watch: {

		},
		methods: {
			begin() {
				if (!this.runBuff) {
					this.runBuff = true
					this.beginButton = true
					setTimeout(() => {
						this.beginButton = false
						this.run()
					}, 100)
				}
			},
			run() {
				let seed = Math.ceil(Math.random() * 6)
				let round = 0
				this.runHandle = setInterval(() => {
					if (round > this.round && this.index == seed) {
						clearInterval(this.runHandle)
						this.card = 0
					} else {
						if (this.index >= 6) {
							this.index = 0
							round++
						}
						this.index++
					}
				}, 60)
			},
			gethongbao(){
				this.hbShow = true
			},
			hongbao(){		
				if(!this.buttonBuff){
					this.buttonBuff = true
					setTimeout(()=>{

					},300)
					this.$store.commit('playYinxiao',{name:'tap'})
				}

			},	
			fudai(){		
				if(!this.buttonBuff){
					this.buttonBuff = true
					setTimeout(()=>{

					},300)
					this.$store.commit('playYinxiao',{name:'tap'})
				}

			},			
			share(){		
				if(!this.buttonBuff){
					this.buttonBuff = true
					setTimeout(()=>{

					},300)
					this.$store.commit('playYinxiao',{name:'tap'})
				}

			},	
			back(){
				this.$emit('back')
			},
			gift(){
				// this.card = 2
				this.$api.gift().then((res)=>{
					this.card = res.gift
					this.money = res.bonusamount
					if(this.card==1){
						this.shareShow = false
						this.hongbaoPath = 'pages/games/money?unionId='+encodeURIComponent(this.userInfo.unionid)+'&bonusAmount='+this.money+'&actType=CNY'
						//console.log(this.hongbaoPath)
					}
					if(this.card==3){
						this.hbtype = Math.ceil(Math.random()*5)
						setTimeout(()=>{
							this.getHb()
						},1000)
					}
				})
				
			},
			getHb() {
				// this.$toast.loading({
				// 	message: '请等待...',
				// 	forbidClick: true,
				// 	duration: 0,
				// })
				return new Promise((resolve)=>{
					html2canvas(this.$refs.model, {
						backgroundColor:null,
						useCORS:true,
						scale: 2
					}).then((canvas) => {
						let hburl = canvas.toDataURL()
						//this.$toast.clear()
						let blob = this.dataURLtoBlob(hburl)
						let file = this.blobToFile(blob, 'demo')
						this.uploadOss(file,resolve)
						//this.$toast.clear()
					});				   
				})
			},			
			uploadOss(files,resolve) {
				
				let that = this
				let client = new OSS({
					region: 'oss-cn-beijing',
					accessKeyId: 'LTAIj8SXBqwG8gVj',
					accessKeySecret: 'z4J54rDyx153boLiwS2xd96l982IPR',
					bucket: '0807face'
				});
				let name = 'milk/' + (new Date()).valueOf() + '.png'
				client.put(name, files).then((res) => {
					let img = new Image()
					img.src = res.url
					img.onload = () => {
						
						that.hb = res.url
						console.log(res.url)
						// that.$toast.clear()
						resolve()
					}

				}).catch((err) => {
					that.buff = true
					// that.$toast.clear()
					window.console.log(err)
				})
			},
			dataURLtoBlob(dataurl) {
				let arr = dataurl.split(','),
					mime = arr[0].match(/:(.*?);/)[1],
					bstr = atob(arr[1]),
					n = bstr.length,
					u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new Blob([u8arr], {
					type: mime
				});
			},
			blobToFile(theBlob, fileName) {
				theBlob.lastModifiedDate = new Date();
				theBlob.name = fileName;
				return theBlob;
			},
			shareHide(){
				this.shareShow = false
				// this.$store.commit('setCurrentPage', {
				// 	page: 'p2'
				// })
			}		
		},
		components: {

		}
	}
</script>
